.contact-detail-screen-wrapper {
  position: relative;
  padding: 1.6rem;
  overflow: auto;
  width: 100%;
}
